import { useMemo } from 'react';
import { CART_ITEMS_TYPES_ORDER } from '../constants';
export const useOrganizedCartItems = ({ items, }) => {
    const groupedItems = useMemo(() => {
        var _a;
        const tempGroupedItems = {};
        for (const item of items) {
            const { line_itemable_id: lineItemableId, line_itemable_type: lineItemableType, } = item;
            if (!lineItemableId) {
                continue;
            }
            switch (lineItemableType) {
                case 'Ecommerce::PromoCode': {
                    tempGroupedItems[item.id] = Object.assign(Object.assign({}, item), { quantity: 1 });
                    break;
                }
                default: {
                    const compoundKey = `${lineItemableId}-${lineItemableType}`;
                    const quantity = (((_a = tempGroupedItems[compoundKey]) === null || _a === void 0 ? void 0 : _a.quantity) || 0) + item.quantity;
                    tempGroupedItems[compoundKey] = Object.assign(Object.assign({}, item), { quantity });
                }
            }
        }
        return Object.values(tempGroupedItems);
    }, [items]);
    const orderedGroupedItems = useMemo(() => groupedItems.sort((a, b) => {
        const aIndex = CART_ITEMS_TYPES_ORDER.indexOf(a.line_itemable_type);
        const bIndex = CART_ITEMS_TYPES_ORDER.indexOf(b.line_itemable_type);
        if (aIndex === -1 && bIndex !== -1) {
            return 1;
        }
        if (bIndex === -1 && aIndex !== -1) {
            return -1;
        }
        return aIndex - bIndex;
    }), [groupedItems]);
    const promoCodeItems = useMemo(() => orderedGroupedItems.filter(({ line_itemable_type: type }) => type === 'Ecommerce::PromoCode'), [orderedGroupedItems]);
    const orderedItems = useMemo(() => orderedGroupedItems.filter(({ line_itemable_type: type }) => type !== 'Ecommerce::PromoCode'), [orderedGroupedItems]);
    return {
        orderedItems,
        promoCodeItems,
    };
};
//# sourceMappingURL=useOrganizedCartItems.js.map